// Penggal: P1 Feb-Mei, P2 Jun-Nov (selaras backend). Jan -> P1, Dis -> P2.
export const TERM_MONTHS = { 1: "Feb - Mei", 2: "Jun - Nov" };
const TERM1_LAST_MONTH_INDEX = 4; // Mei (getMonth: 0 = Jan)

export const currentTermKey = (date = new Date()) =>
  `${date.getFullYear()}-P${date.getMonth() <= TERM1_LAST_MONTH_INDEX ? 1 : 2}`;

export const termLabel = (key) => {
  const m = /^(\d{4})-P([12])$/.exec(key || "");
  return m ? `Penggal ${m[2]} ${m[1]}` : key || "-";
};

export const termMonths = (key) => {
  const m = /^(\d{4})-P([12])$/.exec(key || "");
  return m ? TERM_MONTHS[m[2]] : "";
};

// Senarai penggal: semasa + 5 penggal sebelumnya + penggal yang wujud dalam sejarah
export const buildTermOptions = (extraKeys = []) => {
  const now = new Date();
  let year = now.getFullYear();
  let term = now.getMonth() <= TERM1_LAST_MONTH_INDEX ? 1 : 2;
  const keys = [];
  for (let i = 0; i < 6; i += 1) {
    keys.push(`${year}-P${term}`);
    term -= 1;
    if (term === 0) { term = 2; year -= 1; }
  }
  extraKeys.forEach((k) => { if (k && /^(\d{4})-P([12])$/.test(k) && !keys.includes(k)) keys.push(k); });
  return keys.sort((a, b) => (a < b ? 1 : -1));
};
